import { PRODUCT_PRIORITY } from "variables/Variables";

export const PRIORITY_COLORS = {
  [PRODUCT_PRIORITY.unset]: "#606071",
  [PRODUCT_PRIORITY.low]: "#009B72",
  [PRODUCT_PRIORITY.medium]: "#FFD900",
  [PRODUCT_PRIORITY.high]: "#C04F4F",
};
